var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.201 30.9623H1.40918V0H22.2063C23.1981 0 24 0.753605 24 1.6857V29.2766C24 30.2087 23.1928 30.9623 22.201 30.9623Z",
    fill: "#077CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5728 30.4036H1.57764V0.561768H21.5728C22.5013 0.561768 23.2558 1.27075 23.2558 2.14335V28.817C23.261 29.6946 22.5066 30.4036 21.5728 30.4036Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7918 30.9623H0.89688C0.400958 30.9623 0 30.5855 0 30.1194V0.842848C0 0.376803 0.400958 0 0.89688 0H20.7918C21.7836 0 22.5856 0.753605 22.5856 1.6857V29.2766C22.5856 30.2087 21.7836 30.9623 20.7918 30.9623Z",
    fill: "#077CA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1087 0H17.0459V30.9672H19.1087V0Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31836 30.9866V33.5002L4.66895 32.7466L6.02483 33.5002V30.9866H3.31836Z",
    fill: "#074B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookreport);
export default __webpack_public_path__ + "static/media/bookreport.cb3373e88e59e0141223aee0d75f14e5.svg";
export { ForwardRef as ReactComponent };